export default "__VITE_ASSET__BEYPGth6__"